import React, { useEffect, useState } from 'react';
import { calculateTotal } from '../CartHelper/CartHelper';
import AddressBook from '../AccountPage/AddressBook';

const CheckoutContainer = ({ data }) => {
    const items = data?.Items?.$values || [];
    const addresses = data?.Profile?.Addresses?.$values || [];
    const [selectedAddress, setSelectedAddress] = useState(addresses[0]?.Id);
    const [selectedPaymentMethod] = useState('qrcode');
    const [loading, setLoading] = useState(false);
    const [timers, setTimers] = useState(items.map((item) => Number.parseInt(item.ReservedForCheckoutSeconds, 10) || 0));
    const hasReservationTimers = timers.some((timer) => timer > 0);

    useEffect(() => {
        if (!hasReservationTimers) {
            return undefined;
        }

        const interval = setInterval(() => {
            setTimers((currentTimers) => currentTimers.map((timer) => (timer > 0 ? timer - 1 : 0)));
        }, 1000);

        return () => clearInterval(interval);
    }, [hasReservationTimers]);

    const handleSubmit = () => {
        setLoading(true);
        window.location.href = '/Checkout/Finish';
    };

    const { total, deliveryCost, totalWithDelivery } = calculateTotal(items);
    const isCheckoutDisabled = !selectedAddress || !selectedPaymentMethod || loading;

    return (
        <div className="checkout-container">
            <div className="container mx-auto p-6">
                <div className="mg-header__top">
                    <div className="mg-header__logo">
                        <img alt="logo" src="/img/svg/merkuls_logo.svg" />
                    </div>
                </div>
                <h2 className="text-2xl font-semibold mb-4">Оформление заказа</h2>

                <div className="mb-6">
                    <AddressBook
                        data={addresses}
                        isCheckout={true}
                        selectedAddress={selectedAddress}
                        setSelectedAddress={setSelectedAddress}
                    />
                </div>

                <div className="mb-6">
                    <h3 className="text-lg font-semibold mb-2">Способ доставки</h3>
                    <p>Стандартная доставка СДЭК</p>
                </div>

                <div className="mb-6">
                    <h3 className="text-lg font-semibold mb-2">Способ оплаты</h3>
                    <div className="flex space-x-4">
                        <button key="qrcode" className="px-4 py-2 border rounded-md bg-black text-white">
                            QR-code
                        </button>
                    </div>
                </div>

                <div className="cart-items w-full">
                    <ul>
                        {items.map((cartItem, index) => {
                            const isOutOfStock = !cartItem.IsInStock;
                            const cooldown = timers[index] || 0;
                            const isPreorder = cartItem.ProductKindName === 'aproduct' || cartItem.Product?.IsForOrder === true;
                            const sourceImageUrl = cartItem.Product.ImagesPath.$values[0].URL;
                            const imageUrl = sourceImageUrl.startsWith('/img/products/')
                                ? sourceImageUrl.replace('/img/products/', '/img/products/300x300/')
                                : sourceImageUrl;
                            const sizeLabel = cartItem.SizeStr || cartItem.Product.SizeStr || 'Размер уточняется';

                            return (
                                <li key={`${cartItem.ProductKindName}:${cartItem.Product.ProductId}`} className="flex items-center gap-4 p-4 border-b border-gray-200">
                                    <div className={`relative w-24 h-24 rounded-md overflow-hidden ${isOutOfStock ? 'opacity-50' : ''}`}>
                                        <img
                                            src={imageUrl}
                                            alt={cartItem.Product.Title || 'Product Image'}
                                            className="w-full h-full object-cover"
                                        />
                                        {isOutOfStock && (
                                            <span className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white text-sm font-semibold">
                                                Недоступно
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-grow">
                                        <h3 className="font-semibold">
                                            {cartItem.Product.BrandName} {cartItem.Product.Title}
                                        </h3>
                                        <p className="text-gray-500 text-sm">{isPreorder ? 'Под заказ' : 'В наличии'}</p>
                                        <p className="text-gray-600">Размер: {sizeLabel}</p>
                                        <p className="text-gray-800 font-semibold">{cartItem.Price} ₽</p>
                                        {cooldown > 0 && (
                                            <p className="text-black text-sm font-medium">
                                                Зарезервировано на {cooldown} сек.
                                            </p>
                                        )}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                <aside className="cart-summary w-full mt-6 md:mt-0">
                    <div className="bg-gray-100 p-4 rounded-lg shadow-md">
                        <h2 className="text-xl font-bold">Сумма заказа</h2>
                        <div className="mt-4">
                            <p className="flex justify-between text-gray-700">
                                <span>Товары</span> <span>{total} ₽</span>
                            </p>
                            <p className="flex justify-between text-gray-700">
                                <span>Доставка</span> <span>{deliveryCost} ₽</span>
                            </p>
                            <hr className="my-2" />
                            <p className="flex justify-between font-semibold text-lg">
                                <span>Итого</span> <span>{totalWithDelivery} ₽</span>
                            </p>
                        </div>

                        <button
                            onClick={handleSubmit}
                            disabled={isCheckoutDisabled}
                            className="w-full mt-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800"
                        >
                            Оформить и оплатить
                        </button>
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default CheckoutContainer;
